import type { IServiceOrganizationSettings } from '@frontend/components/interfaces/serviceOrganizationSettings';
import { fetchJson } from '../../store/fetch';

export async function getServiceOrganizationSetting(organizationId: string, serviceId: string) {
    const url = `/api/serviceOrganizationSettings?organizationId=${organizationId}&serviceId=${serviceId}&isActive=true`;
    const serviceOrganizationSettings: IServiceOrganizationSettings[] = (await fetchJson(url, 'GET')).json.items;
    if (serviceOrganizationSettings.length) {
        return serviceOrganizationSettings[0];
    }
}
